import { createAsyncThunk } from '@reduxjs/toolkit';
import axios  from 'config/axios';

import { setThreatActors, setMitreMappings, setErrors,setDimensions, setSeverities, setAvailableDimensions, setThreatDetails, setSelectedThreatDetails } from '../../../stores/modules/ecs/datareducer';

export const fetchThreatActors = createAsyncThunk('data/fetchThreatActors', async ({idToken, params }, { dispatch }) => {
  try {
    dispatch(setThreatActors([]));
    setErrors([]);
    const response = await axios.get(`${process.env.REACT_APP_CRS_DASHBOARD_ENDPOINT_URL}/dashboard/apt-list`, {
      params: params,
    });
    if (response.status === 200){
      dispatch(setThreatActors(response.data.data));
    }
    else{
      dispatch(setErrors(response.data));
    }
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});

export const fetchMitreMappings = createAsyncThunk('data/fetchMitreMappings', async ({idToken, params }, { dispatch }) => {
  try {
    dispatch(setMitreMappings([]));
    setErrors([]);
    const response = await axios.get(`${process.env.REACT_APP_CRS_DASHBOARD_ENDPOINT_URL}/dashboard/mitremapping`, {
      params: params,
    });
    if (response.status === 200){
      dispatch(setMitreMappings(response.data.data));
    }
    else{
      dispatch(setErrors(response.data));
    }
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});

export const fetchOverAllScore = async ({ idToken, params }) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_CRS_DASHBOARD_ENDPOINT_URL}/dashboard/overall-score`, {
      params: params,
    });
    if (response.status === 200){
      return response.data;
    }
    else{
      return response.data;
    }
  } catch (error) {
    return error
  }
};

export const fetchAlertAnalysis = async ({ idToken, params }) => {
  try {
    let response;
    if (params.compliance){
      delete params.compliance;
      response = await axios.get(`${process.env.REACT_APP_CRS_DASHBOARD_ENDPOINT_URL}/dashboard/compliance/alerts-analysis`, {
        params: params,
      });
    }
    else{
      response = await axios.get(`${process.env.REACT_APP_CRS_DASHBOARD_ENDPOINT_URL}/dashboard/alerts-analysis`, {
        params: params,
      });
    }
    if (response.status === 200){
      return response.data;
    }
    else{
      return response.data;
    }
  } catch (error) {
    return error
    // dispatch(setErrors(error.response));
  }
};

export const fetchAlertsTrend = async ({ idToken, params }) => {
  try {
    let response;
    if (params.compliance){
      delete params.compliance;
      response = await axios.get(`${process.env.REACT_APP_CRS_DASHBOARD_ENDPOINT_URL}/dashboard/alerts-trend`, {
        params: params,
      });
    }
    else {
      response = await axios.get(`${process.env.REACT_APP_CRS_DASHBOARD_ENDPOINT_URL}/dashboard/alerts-trend`, {
        params: params,
      });
    }
    return response;
  } catch (error) {
    return error;
  }
};

export const fetchDomainsPerfomance = async ({ idToken, params }) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_CRS_DASHBOARD_ENDPOINT_URL}/dashboard/domain-performance`, {
      params: params,
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const fetchDomainsHeatmapPerfomance = async ({ idToken, params }) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_CRS_DASHBOARD_ENDPOINT_URL}/dashboard/getDomainPerformanceHeatmap`, {
      params: params,
    });
    return response;
  } catch (error) {
    return error;
  }
};


export const fetchDimensions = createAsyncThunk('company/fetchDimensions', async ({ idToken }, { dispatch }) => {
  try {
    dispatch(setDimensions([]));
    setErrors([]);
    const response = await axios.get(`${process.env.REACT_APP_CRS_DIMENSION_ENDPOINT_URL}/dimensions`, {
    });
    if (response.status === 200){
      dispatch(setDimensions(response.data));
    }
    else{
      dispatch(setErrors(response.data));
    }
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});

export const fetchSeverities = createAsyncThunk('company/fetchSeverities', async ({ idToken }, { dispatch }) => {
  try {
    dispatch(setSeverities([]));
    setErrors([]);
    const response = await axios.get(`${process.env.REACT_APP_CRS_SEVERITY_ENDPOINT_URL}/severities`, {});
    const severities = response.data.sort((a, b) => {
      if (a.grade < b.grade) {
        return -1;
      }
      if (a.grade > b.grade) {
        return 1;
      }
      return 0;
    });
    dispatch(setSeverities(severities));
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});
export const fetchAvailableDimensions = createAsyncThunk('data/fetchAvailableDimensions', async ({ params, idToken }, { dispatch }) => {
  try {
    const updatedParams = { ...params };
    const headers = {
      Authorization: `Bearer ${idToken}`,
    };

    let response = await axios.get(`${process.env.REACT_APP_CRS_DASHBOARD_ENDPOINT_URL}/dashboard/available-dimensions`, {
      params: updatedParams,
      headers: headers,
    });

    dispatch(setAvailableDimensions(response.data));
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});
export const fetchThreatActorsByDomain = createAsyncThunk('data/fetchThreatActorsByDomain',async ({ params },{dispatch}) => {
  try {
    dispatch(setThreatDetails([]));
    const response = await axios.get(`${process.env.REACT_APP_CRS_IUI_ENDPOINT_URL}/iui/threatactors`, {
      params: params,
    });
    if (response.status === 200){
      dispatch(setThreatDetails(response.data));
    }
  } catch (error) {
    return error?.response?.data?.message;
  }
});

export const fetchOverAllThreatActors = createAsyncThunk('data/fetchThreatActorsByDomain',async ({ params },{dispatch}) => {
  try {
    dispatch(setThreatDetails([]));
    const response = await axios.get(`${process.env.REACT_APP_CRS_IUI_ENDPOINT_URL}/iui/threatactors`, {
      params: params,
    });
    if (response.status === 200){
      dispatch(setSelectedThreatDetails(response.data));
    }
  } catch (error) {
    return error?.response?.data?.message;
  }
});

export const addThreatActor = async (data) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_CRS_IUI_ENDPOINT_URL}/iui/addThreatactor`,data, {
      'Content-Type': 'application/json',
    });
    return response;
  } catch (error) {
  }
};

export const editThreatActor = async (data, id) => {
  try {
    const response = await axios.put(`${process.env.REACT_APP_CRS_IUI_ENDPOINT_URL}/iui/editThreatactor/${id}`,data, {
      'Content-Type': 'application/json',
    });
    return response;
  } catch (error) {
  }
};

export const deleteThreatActor = async (id) => {
  try {
    const response = await axios.put(`${process.env.REACT_APP_CRS_IUI_ENDPOINT_URL}/iui/deleteThreatactor/${id}`, {
      'Content-Type': 'application/json',
    });
    return response;
  } catch (error) {
  }
};

export const fetchAllThreatActors = async ({ params }) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_CRS_IUI_ENDPOINT_URL}/iui/getAllThreatactors`, {
      params: params,
    });
    if (response.status === 200){
      return response.data;
    }
    else{
      return response.data;
    }
  } catch (error) {
  }
};

export const fetchSingleThreatActorData = async ({ params }) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_CRS_IUI_ENDPOINT_URL}/iui/single-threatactor`, {
      params: params,
    });
    if (response.status === 200){
      return response.data;
    }
    else{
      return response.data;
    }
  } catch (error) {
  }
};

export const fetchThreatActorDataByID = async ({ params }) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_CRS_IUI_ENDPOINT_URL}/iui/getThreatactorByID`, {
      params: params,
    });
    if (response.status === 200){
      return response.data;
    }
    else{
      return response.data;
    }
  } catch (error) {
  }
};


export const fetchNodeGraph = async ( params ) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_CRS_IUI_ENDPOINT_URL}/iui/threatactors-graph`, {
      params: params,
    });
    if (response.status === 200){
      return response.data;
    }
    else{
      return response.data;
    }
  } catch (error) {
  }
};

export const fetchVulnerabilityDetails = async(params) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_CRS_IUI_ENDPOINT_URL}/iui/threatactors-alerts`, {
      params: params,
    });
    if (response.status === 200){
      return response.data;
    }
    else{
      return response.data;
    }
  } catch (error) {
    
  }
}

export const saveNewDimension= async({body})=>{
  try{
    let response= await axios.post(`${process.env.REACT_APP_CRS_DIMENSION_ENDPOINT_URL}/createDimension`,body,
    {
      'Content-Type': 'application/json',
    });
   return response;
  }catch(error){
    return error.response;
  }

}
export const saveNewSubDimensionByDimension= async({dimension,body})=>{
  try{
    let response= await axios.post(`${process.env.REACT_APP_CRS_DIMENSION_ENDPOINT_URL}/createSubdimension?dimension=`+dimension,body,
    {
      'Content-Type': 'application/json',
    });
   return response;
  }catch(error){
    return error.response;
  }
}
export const updateDimensionById = async(dimensionId,{body})=>{
  try{
    let response = await axios.put(`${process.env.REACT_APP_CRS_DIMENSION_ENDPOINT_URL}/dimension/`+dimensionId,body,
      {
        'Content-Type': 'application/json',
      }
    )
    return response;
  }catch(error){
    return error;   
  }
}

export const fetchECSDimensions= async()=>{
  try{
    let response = await axios.get(`${process.env.REACT_APP_CRS_DIMENSION_ENDPOINT_URL}/alldimensions`,{
    })
    return response;
  }catch(error){
    return error;   
  }
  
}

export const fetchECSSubDimensionsByDimensionId = async({dimensionId})=>{
  try{
    let response = await axios.get(`${process.env.REACT_APP_CRS_DIMENSION_ENDPOINT_URL}/subdimensionsBydimension/`+dimensionId,{
    })
    return response;
  }catch(error){
    return error;   
  }
  
}

export const updateDimensionweightages = async({body})=>{
  try{
    let response = await axios.put(`${process.env.REACT_APP_CRS_DIMENSION_ENDPOINT_URL}/dimensions/update-weights`,body,
      {
        'Content-Type': 'application/json',
      }
    )
    return response;
  }catch(error){
    return error;   
  }
}